import React from 'react';

import Hero from 'components/Hero';
import SiteFooter from 'components/SiteFooter';
import SiteHeader from 'components/SiteHeader';
import background from 'static/images/background@2x.jpg';

export interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
  /** Wider content column for tables and resource pages */
  wide?: boolean;
  /** Shown under the title in the marketing hero */
  lede?: string;
  /**
   * marketing — same hero shell as the home page (photo + onHero header)
   * plain — solid green header for legal/docs pages
   */
  variant?: 'plain' | 'marketing';
  /** Wider than `wide` for configurator layouts */
  extraWide?: boolean;
}

const LegalPageLayout = ({
  title,
  children,
  wide = false,
  lede,
  variant = 'plain',
  extraWide = false,
}: LegalPageLayoutProps) => {
  const shellClass = extraWide
    ? 'gb-page-shell--extra-wide mx-auto'
    : wide
      ? 'max-w-4xl mx-auto'
      : 'max-w-2xl mx-auto';

  if (variant === 'marketing') {
    return (
      <div className="min-h-screen flex flex-col bg-white text-black">
        <Hero as="div" background={background} className="gb-page-hero text-white">
          <SiteHeader variant="onHero" showHome />
          <div className="container gb-page-hero__inner">
            <h1 className="gb-page-hero__title m-0">{title}</h1>
            {lede ? <p className="gb-page-hero__lede m-0 gb-form-lede">{lede}</p> : null}
          </div>
        </Hero>

        <main className="container flex-1 gb-page-main px-15 md:px-25">
          <div className={shellClass}>{children}</div>
        </main>

        <SiteFooter />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-white text-black">
      <SiteHeader variant="onGreen" showHome />

      <main className="container flex-1 py-75 px-15 md:px-25">
        <div className={shellClass}>
          <h1 className="text-2xl font-bold mb-35 text-black">{title}</h1>
          <div className="text-base leading-normal text-black">{children}</div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default LegalPageLayout;



// WEBPACK FOOTER //
// ./src/components/LegalPageLayout.tsx